module.exports = __webpack_public_path__ + "static/img/logoTN.6dfe72d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoTN.png
// module id = m8dC
// module chunks = 1